import { Check, ChevronRight } from "lucide-react"
import React from "react"

interface TourPrevButtonProps {
  currentStep: number
  onBack: () => void
  backLabel: string
}

export const TourPrevButton: React.FC<TourPrevButtonProps> = ({
  currentStep,
  onBack,
  backLabel,
}) => {
  if (currentStep === 0) {
    return <span />
  }

  return (
    <button
      onClick={onBack}
      className="text-zinc-300 border-zinc-600 hover:border-zinc-500 hover:bg-zinc-700/50 cursor-pointer whitespace-nowrap rounded border px-3 py-1.5 text-sm font-medium transition-all"
    >
      {backLabel}
    </button>
  )
}

interface TourNextButtonProps {
  isLastStep: boolean
  isFinalTour: boolean
  needsManualAdvance: boolean
  onComplete: () => void
  onAdvance: () => void
  finishLabel: string
  allSetLabel: string
  nextLabel: string
}

export const TourNextButton: React.FC<TourNextButtonProps> = ({
  isLastStep,
  isFinalTour,
  needsManualAdvance,
  onComplete,
  onAdvance,
  finishLabel,
  allSetLabel,
  nextLabel,
}) => {
  if (isLastStep) {
    return (
      <button
        onClick={onComplete}
        className="flex cursor-pointer items-center whitespace-nowrap rounded bg-yellow1 px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-yellow1/90"
      >
        {isFinalTour ? finishLabel : allSetLabel}
        {!isFinalTour && <Check className="ml-1 h-4 w-4" />}
      </button>
    )
  }

  if (needsManualAdvance) {
    return (
      <button
        onClick={onAdvance}
        className="flex cursor-pointer items-center whitespace-nowrap rounded bg-yellow1 px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-yellow1/90"
      >
        {nextLabel}
        <ChevronRight className="ml-1 h-4 w-4" />
      </button>
    )
  }

  return null
}
